module.exports = __webpack_public_path__ + "static/media/04_360.269622ee.jpeg";